import { api } from "../api/http.js";
import type { Bundle } from "./types.js";

type Text = { de: string; en: string };

export interface LuckyMission { id: string; name: Text; target: number; progress: number; reward: number; claimed: boolean; claimable: boolean }
export interface LuckyPack { price: number; perDay: number; boughtToday: number; tickets?: number; keys?: number }

export interface LuckyHubSummary {
  wheel: { freeLeft: number; price: number };
  capsule: { freeLeft: number; price: number; keys: number };
  vault: { shots: number; revealed: number; round: number; keys?: number };
  discount: { coupons: number; shopUntil: number | null };
  memory: { free: boolean; drawsLeft: number; tickets: number };
  gacha: { active: boolean; keys: number };
  claimable: number;
  /** D140: where the badge's rewards wait. Absent on old payloads. */
  claimableBy?: { memory: number; gacha: number; vault: number; milestones: number };
}

export interface MemoryView {
  day: string;
  revealMs: number;
  tiles: { index: number; prizeId: string; reward: Bundle; drawn: boolean }[];
  drawsToday: number;
  drawsPerDay: number;
  nextCost: number | null;
  tickets: number;
  totalDraws: number;
  grandIn: number;
  grand: Bundle;
  odds: { id: string; pct: number }[];
  missions: LuckyMission[];
  pack: LuckyPack;
}

export interface GachaView {
  active: boolean;
  runId: string | null;
  endsAt: number | null;
  nextStartsAt: number | null;
  week: { id: string; name: Text; bronze: { id: string; reward: Bundle }[]; silver: { id: string; reward: Bundle }[]; gold: Bundle; bronzeOdds: { id: string; pct: number }[]; silverOdds: { id: string; pct: number }[] };
  keys: number;
  goldKeys: number;
  silverFrom: number;
  opened: number;
  chest: "bronze" | "silver";
  milestones: { index: number; points: number; reward: Bundle; claimed: boolean; claimable: boolean }[];
  missions: LuckyMission[];
  pack: LuckyPack;
}

/** The Lucky hub (D106): summary, Wild Memory, Key Gacha, missions and packs. */
export const luckyHubApi = {
  hub: () => api<LuckyHubSummary>("GET", "/api/lucky/hub"),
  memory: () => api<MemoryView>("GET", "/api/lucky/memory"),
  draw: (index: number) => api<{ index: number; prizeId: string; reward: Bundle; grand: boolean; cost: number; granted: Bundle }>("POST", "/api/lucky/memory/draw", { index }),
  gacha: () => api<GachaView>("GET", "/api/lucky/gacha"),
  open: (count: 1 | 10) => api<{ chest: "bronze" | "silver" | "gold"; prizes: { id: string; reward: Bundle }[]; granted: Bundle; opened: number }>("POST", "/api/lucky/gacha/open", { count }),
  claimMission: (id: string) => api<{ game: "memory" | "gacha"; itemId: string; qty: number }>("POST", `/api/lucky/missions/${id}/claim`),
  vaultKeys: () => api<{ keys: number; missions: LuckyMission[]; pack: LuckyPack & { keys: number } }>("GET", "/api/lucky/vault/keys"),
  buyPack: (game: "memory" | "gacha" | "vault") => api<{ itemId: string; qty: number }>("POST", `/api/lucky/packs/${game}`),
  claimMilestone: (runId: string, index: number) => api<{ granted: Bundle }>("POST", `/api/events/${runId}/milestones/${index}`),
};
